export const BASE_KEEP_KEYS = ['employee_information', 'exclude_from_payout_reason', 'manual_average_value', 'is_example'];
export const REFERENCE_FIELD_KEYS = ['reference_balanced_scorecard_setting_name', 'reference_budget_name', 'reference_group_name'];

// Body of `POST /employees/new` and `PUT /employees/:hash_id` from the master data form values.
// Returns a new object, `data` is not changed. Every option is a difference between the
// former copies in `EmployeeRow` and `DB-EmployeeRow` (see findings of add-employee-row-tests):
// - stateEmployeeYupObj: state-employee schema (DB). Keys stored in `employees` are sent top-level,
//   the others as `employee_information` entries.
// - filterCalculationFields: also keep top-level keys of calculation related fields.
// - keepKeys: top-level keys that are never filtered.
// - skipStateKeysInInformation: leave state-employee keys out of the form's `employee_information` (DB update).
// - dropReferenceKeys: remove the `reference_*_name` keys first (normal).
export function buildEmployeePayload(data, { fixedFieldsData, calculationRelatedFieldsData, conditionalFieldsData, systemFieldsData, freeFieldsData }, {
  stateEmployeeYupObj = null,
  filterCalculationFields = true,
  keepKeys = BASE_KEEP_KEYS,
  skipStateKeysInInformation = false,
  dropReferenceKeys = false,
} = {}) {
  const formData = { ...data };
  if (dropReferenceKeys) REFERENCE_FIELD_KEYS.forEach(key => delete formData[key]);

  const stateLinkedFields = {};
  const employeeInformation = [];

  for (const key in stateEmployeeYupObj) {
    if (stateEmployeeYupObj[key].describe().meta?.stored_in_table === 'employees') {
      stateLinkedFields[key] = formData[key];
    } else {
      employeeInformation.push({ key, value: formData[key] === undefined ? null : formData[key] });
    }
  }

  // remove field if not enabled for employee_data, except for the keep keys
  const enabledFields = filterCalculationFields ? [...fixedFieldsData, ...calculationRelatedFieldsData] : fixedFieldsData;
  const updatedFixedFields = [];
  for (const key in formData) {
    if (keepKeys.includes(key)) continue;

    const found = enabledFields.filter(f => f.key === key || f.key + '_hash_id' === key);
    if (found.length < 1) delete formData[key];
    else updatedFixedFields.push(found[0].name);
  }

  for (const key in formData.employee_information) {
    const foundFixed = fixedFieldsData.filter(f => !updatedFixedFields.includes(f.name) && f.name === key);
    const found = [...conditionalFieldsData, ...systemFieldsData, ...freeFieldsData].filter(f => f.name === key);
    const skipped = skipStateKeysInInformation && !!stateEmployeeYupObj?.[key];

    // only push enabled employee_data fields
    if ((foundFixed.length > 0 || found.length > 0) && !skipped) {
      employeeInformation.push({ key, value: formData.employee_information[key] });
    }
  }
  formData.employee_information = employeeInformation;

  return { ...formData, ...stateLinkedFields };
}
